import { createAuthentication } from "@cedarjs/auth";
function createAuth(customProviderHooks, authImplementationOptions) {
  const authImplementation = createAuthImplementation(authImplementationOptions);
  return createAuthentication(authImplementation, customProviderHooks);
}
function createAuthImplementation({
  defaultGetTokenOptions = {}
} = {}) {
  return {
    type: "clerk",
    // Using a getter here to make sure we're always returning a fresh value
    // and not creating a closure around an old (probably `undefined`) value
    // for Clerk that'll we always return, even when Clerk on the window object
    // eventually refreshes
    get client() {
      return typeof window === "undefined" ? void 0 : window.Clerk;
    },
    login: async (options) => {
      const clerk = window.Clerk;
      clerk?.openSignIn(options || {});
    },
    logout: async (callbackOrOptions, options) => {
      const clerk = window.Clerk;
      return clerk?.signOut(callbackOrOptions, options);
    },
    signup: async (options) => {
      const clerk = window.Clerk;
      clerk?.openSignUp(options || {});
    },
    getToken: async (options) => {
      const clerk = window.Clerk;
      let token;
      try {
        token = await clerk?.session?.getToken({
          ...defaultGetTokenOptions,
          ...options
        });
      } catch {
        token = null;
      }
      return token || null;
    },
    getUserMetadata: async () => {
      const clerk = window.Clerk;
      return clerk?.user;
    },
    clientHasLoaded: () => {
      return window.Clerk !== void 0;
    },
    loadWhileReauthenticating: true
  };
}
export {
  createAuth
};
